export enum IssueApprovalStatusEnum {
  NOT_SET = 'not-set',
  WAITING_FOR_APPROVAL = 'waiting-for-approval',
  APPROVED = 'approved',
  DENIED = 'denied',
}

export type IssueApprovalStatusType =
  | 'not-set'
  | 'waiting-for-approval'
  | 'approved'
  | 'denied';
